<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle="Report Abuse" [showBackButton]="false">
    <ng-template #addButton>
      <div class="d-flex search-field">
  
        <button
        mat-icon-button
        mat-dialog-close
        class="align-self-end"
        color="accent"
      >
        <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
      </button>
      </div>
    </ng-template>
  </sm-misc-title-bar>

  <mat-dialog-content>
    <div>
        <h2>Help us understand what's wrong!</h2>
        <p>Please select an option from the below to specify the reason you think this is an abuse. Also kindly elaborate in writing. We shall look into the matter and do the needful.</p>
    </div>
    <div class="chip_cont">
        <mat-chip-list aria-label="Fish selection" class="mb-3">
          <mat-chip
            style="height: auto"
            [ngClass]="{'selected': allReportTypeStatus[0].status == true}"
            (click)="changeReportStatus(0)"
            >Spam
          </mat-chip>
          <mat-chip
          style="height: auto"
          (click)="changeReportStatus(1)"
          [ngClass]="{'selected': allReportTypeStatus[1].status == true}"
          >Violence
        </mat-chip>
        <mat-chip
        style="height: auto"
        (click)="changeReportStatus(2)"
        [ngClass]="{'selected': allReportTypeStatus[2].status == true}"
        >Offence
      </mat-chip>
      <mat-chip
          (click)="changeReportStatus(3)"
            style="height: auto"
            [ngClass]="{'selected': allReportTypeStatus[3].status == true}"
            >False News
          </mat-chip>
          <mat-chip
          style="height: auto"
          (click)="changeReportStatus(4)"
          [ngClass]="{'selected': allReportTypeStatus[4].status == true}"
          >Political Issue
        </mat-chip>
        <mat-chip
        style="height: auto"
        (click)="changeReportStatus(5)"
        [ngClass]="{'selected': allReportTypeStatus[5].status == true}"
        >Something Else
      </mat-chip>
        </mat-chip-list>
      
     
      </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Notes</mat-label>
          <textarea
          [(ngModel)]="message"
            matInput
          ></textarea>
         
        </mat-form-field>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    [disabled]="!message"
      mat-flat-button
      color="accent"
      (click)="submit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
